export default __webpack_public_path__ + "static/media/img-game.fafc2192.jpg";